import { NO_PROMOTION } from 'self-service-api/constants/Promotions';
export const getAllEligiblePromotions = ({
  promotions
}) => {
  if (!promotions) return [];
  const allPromotions = Object.values(promotions.productsEligibleForDirectPromotions || {});
  const uniquePromotions = {};
  for (const promotion of allPromotions) {
    for (const versionSpecificPromotion of Object.values(promotion)) {
      const {
        eligiblePromotion,
        eligiblePromotionId
      } = versionSpecificPromotion;
      if (eligiblePromotion && eligiblePromotion !== NO_PROMOTION) {
        uniquePromotions[eligiblePromotion] = true;
      }

      // HSFS_SEED_V3 is only returned in eligiblePromotionId field
      if (eligiblePromotionId && eligiblePromotionId !== NO_PROMOTION) {
        uniquePromotions[eligiblePromotionId] = true;
      }
    }
  }
  return Object.keys(uniquePromotions);
};